import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { UnknownAction } from "redux-saga";

import _ from "lodash";

export interface IUseFetchProps {
  action: (requestBody?: any) => UnknownAction,
  loading: boolean,
  succeeded: boolean,
  response: any[],
  error: any;
}

interface IUseFetchReturn {
  handleFetch: (requestBody: any) => Promise<any>
}

export const useFetch = (props: IUseFetchProps): IUseFetchReturn => {

  const { action, loading, succeeded, response, error } = props;
  const dispatch = useDispatch();

  const promiseRef = useRef<Promise<any> | null>(null);
  const resolveRef = useRef<(value: any | PromiseLike<any>) => void>();
  const rejectRef = useRef<(value: any | PromiseLike<any>) => void>(); 

  useEffect(() => {

    if (!loading && succeeded && resolveRef.current) {
      resolveRef.current(response);
    }

    if (!loading && !succeeded && error && rejectRef.current) {
      rejectRef.current(error);
    }

  }, [loading, succeeded, error]);

  const handleFetch = (requestBody: any) => {

    promiseRef.current = new Promise((resolve, reject) => {

      dispatch(action(requestBody));

      resolveRef.current = resolve;
      rejectRef.current = reject;

    });

    return promiseRef.current;
  }

  return {
    handleFetch: handleFetch
  };

}

